import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faShareNodes } from "@fortawesome/free-solid-svg-icons";
import ProfileCardModal from "./profile-card-modal";

export default function ShareProfileCardButton() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="text-blue-600 hover:text-blue-800 text-sm flex items-center gap-2"
      >
        <FontAwesomeIcon icon={faShareNodes} className="h-4" />
        Share Profile Card
      </button>
      <ProfileCardModal open={open} onClose={() => setOpen(false)} />
    </>
  );
}
